import React from "react";
import styled from "styled-components";
import DesktopList from "./desktop-list";
import MobileList from "./mobile-list";
import {Heading3} from "../../style/itf-styled-components";

const Container = styled.div``;

const Desktop = styled(DesktopList)`
  @media (max-width: 768px) {
    display: none;
  }
`;

const Mobile = styled(MobileList)`
  @media (min-width: 768px) {
    display: none;
  }
`;

export const DataHeading3 = styled(Heading3)`
  color: #ff72f6;
`;

const List = ({list}) => {
  return (
    <Container>
      <Desktop list={list}/>
      <Mobile list={list}/>
    </Container>
  );
};

export default List;